import { Suspense, lazy } from 'react';

import { LazyResolver } from '@ezugi/ui/components/LazyResolver/LazyResolver';
import { DeviceInfo } from '@ezugi/utils';
import { isEvoWrapped } from '@ezugi/utils/src';

const EzugiDesktopHeader = lazy(() => import('../../variants/components/ezugi/EzugiDesktopGameHeader'));

const EvoDesktopHeader = lazy(() => import('../../variants/components/evo/EvoDesktopGameHeader'));

const MobileHeader = lazy(() => import('../../components/MobileHeader'));

const variants = {
  evo: EvoDesktopHeader,
  ezugi: EzugiDesktopHeader,
};

export type GameHeaderProps = {
  className?: string;
  newDesign?: boolean;
};

const GameHeader = (props: GameHeaderProps) => {
  const evoWrapped = isEvoWrapped();

  const { className } = props;

  return (
    <Suspense fallback={null}>
      {DeviceInfo.isHandheld ? (
        <MobileHeader className={className} />
      ) : (
        <LazyResolver
          components={variants}
          componentProps={props}
          variant={evoWrapped ? 'evo' : 'ezugi'}
        />
      )}
    </Suspense>
  );
};

export default GameHeader;
